<template>
  
  <div class="menuContentBox">
    <div style="width: 100%;background-color: #fff;">
  <div class="breadBox">
    <a-breadcrumb>
      <span>
        <img src="@/assets/img/position.png"/>
        当前位置：
      </span>
      <a-breadcrumb-item  @click="$router.push({ path: '/finance/index'})" style="cursor: pointer;">首页</a-breadcrumb-item>
      <a-breadcrumb-item  @click="$router.push({ path: '/finance/investorCenter/index'})" style="cursor: pointer;">{{title}}</a-breadcrumb-item>
    </a-breadcrumb>
  </div>
  <router-view/>
  </div>
  </div>
</template>
<script>

export default {
  name: 'investorCenter',
  props: {
  },
  data() {
    return {
      title:''
    }
  },
  mounted() {
    this.title = this.$route.query.type
  },
	methods: {
		goMore(url) {
			this.$router.push(url)
		},
		backhome() {
      this.goMore('/finance/index')
		}
	}
}
</script>
<style scoped lang="less">
@import "../../css/components.less";
.list_cont{
  width: 592px;
  margin-bottom: 16px;
  &:nth-child(odd){
    margin-right: 16px;
  }
  .list_img{
    width: 100px;
    height: 100px;
    border-radius: 50%;
    overflow: hidden;
    border:1px solid #eeeeee;
    margin:20px 10px 20px 25px;
    flex: 1;
  }
  .list_cont_body{
    flex: 5;
  }
}
</style>